// Developed by Aptus Engineering, Inc. <https://aptusai.com>
// See LICENSE.md file in project root directory

export default (s) => s.substr(0,1).toUpperCase() + s.substr(1)